import { Input } from 'antd'

export const InputUrl = (props) => {
  return <Input style={{ maxWidth: '450px' }} {...props} />
}
